/**
 * Generate an ID.
 */
export function id<P extends string>(prefix: P): `${P}_${string}` {
  return `${prefix}_${new Date().getTime()}${Math.random()
    .toString()
    .slice(3)}`;
}
